import _ from 'underscore';
import axios from 'axios';
import config from 'configuration/configuration.js';

import { SetLoading, RedirectToError } from 'actions/sessionActions';

export const interceptor = (store) => {
	// Add a request interceptor
	axios.interceptors.request.use((configuration) => {
		// Do something before request is sent
		if (!configuration.headers.Authorization) {
			const token = localStorage.getItem(config.TOKEN_KEY);
			if (token) {
				// eslint-disable-next-line no-param-reassign
				configuration.headers.Authorization = `Bearer ${token}`;
			}
		}

		if (configuration.hasLoading !== false || configuration.hasLoading === undefined) {
			store.dispatch(SetLoading(true));
		}

		return configuration;
	}, (error) => {
		// Do something with request error
		store.dispatch(SetLoading(false));
		return Promise.reject(error);
	});

	// Add a response interceptor
	axios.interceptors.response.use((response) => {
		// Any status code that lie within the range of 2xx cause this function to trigger
		// Do something with response data
		store.dispatch(SetLoading(false));
		return response;
	}, (error) => {
		// Any status codes that falls outside the range of 2xx cause this function to trigger
		// Do something with response error
		const { request, response } = error;
		const statusCode = response ? response.status : request.status;

		store.dispatch(SetLoading(false));
		if (statusCode === 401) {
			store.dispatch(RedirectToError('/errors/error-401'));
			return Promise.reject();
		}

		if (statusCode === 404) {
			store.dispatch(RedirectToError('/errors/error-404'));
			return Promise.reject();
		}

		if (statusCode < 599 && statusCode >= 500) {
			store.dispatch(RedirectToError('/errors/error-500'));
			return Promise.reject();
		}

		const errorObject = {
			// eslint-disable-next-line no-nested-ternary
			message: error.response ? (_.isString(error.response.data) ? error.response.data : 'Something went wrong!') : 'Network error!',
			// eslint-disable-next-line no-nested-ternary
			variant: error.response ? (statusCode === 599 ? 'warning' : 'error') : 'error'
		};

		return Promise.reject(errorObject);
	});
};

export default axios;
